export default "__VITE_ASSET__CGwRqM9O__"